var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-tile",
    {
      key: _vm.agentInfos.status,
      staticClass: "itemsListeAgent",
      attrs: { ripple: "", id: "agent_" + _vm.agentInfos.agentID }
    },
    [
      _c("wz-avatar", {
        attrs: {
          src: _vm.agentInfos.avatar,
          username: _vm.agentInfos.agentName,
          size: "38px"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "statusAgent", class: _vm.agentInfos.status }),
      _vm._v(" "),
      _c(
        "v-list-tile-content",
        { staticClass: "wz_truncate listeAgentName" },
        [
          _c("v-list-tile-title", [_vm._v(_vm._s(_vm.agentInfos.agentName))]),
          _vm._v(" "),
          _c("v-list-tile-sub-title", [_vm._v(_vm._s(_vm.agentInfos.jobAgent))])
        ],
        1
      ),
      _vm._v(" "),
      _c("v-badge", { attrs: { color: "green", overlay: "" } }, [
        _vm.sessionsChatAgent.length
          ? _c(
              "span",
              {
                staticClass: "caption",
                attrs: { slot: "badge" },
                slot: "badge"
              },
              [_vm._v(_vm._s(_vm.sessionsChatAgent.length))]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-908f4bba", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-908f4bba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzWatcheeboxAgent.vue
// module id = null
// module chunks = 